import { html } from 'lit';
import { LoadingIcon } from './status-icons';

export const renderLoading = () => html`
  <div id="order-status">
    <div id="icon">${LoadingIcon}</div>
  </div>

  <div id="divider"></div>
  <div id="order-content"></div>
`;
